export default {
    breadcrumbs: {
        practice: 'Practice',
        practice_profile: 'Practice profile',
        practice_services: 'Practice services',
        practice_tests: 'Practice tests',
        practice_tests_list: 'Practice tests list',
        ancillary_profile: 'Ancillary profile',
    },

    titles: {
        practice_profile: '{practiceName} profile',
    },
    buttons: {
        primary: 'Save',
        secondary: 'Cancel',
    },

    total_referrals_received: 'Total referrals rececived',
    total_ancillary_services: 'Services',
    total_referrals_made: 'Total referrals made',
    practice_specialities: 'Specialities',
    practice_locations: 'Locations',
    member_removed: 'Member permanently removed!',
    confirm_leave: 'Do you really want to leave? you have unsaved changes!',
    locations_modal: {
        no: 'No',
        yes: 'Yes',
        set_availability: 'Do you want to set availability for new locations?',
    },
    email_saved: 'Email saved!',
}
